import React from "react";
import { Send } from "react-feather";
import {
  LIBRARY_MODAL_KEYS,
  MODULE_STATES,
  USER_TYPES,
} from "../../../../../storage/constants";
import { StyledItem } from "../../../styles";

const OrganizationCopy = ({
  id,
  userType,
  moduleState,
  setModalState,
  handleClose,
  isRetailerModuleFromMarketplace,
}) => {
  if (isRetailerModuleFromMarketplace) {
    return null;
  }

  if (![USER_TYPES.RETAIL_ADMIN].includes(userType)) return null;

  if (moduleState === MODULE_STATES.CONVERSION) return null;

  return (
    <StyledItem
      onClick={() => {
        setModalState({ key: LIBRARY_MODAL_KEYS.ORG_SHARE, id });
        handleClose();
      }}
    >
      <Send />
      <span>Share Within Organization</span>
    </StyledItem>
  );
};

export default OrganizationCopy;
